import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

/**
 * Used to update Intercom when the location changes (see https://developers.intercom.com/installing-intercom/web/installation#single-page-app)
 */
export const IntercomUpdater = () => {
  const location = useLocation();
  useEffect(() => {
    window.Intercom?.('update');
  }, [location.pathname]);
  return null;
};
